import { BaseOptionDefinition } from './base-option-definition'
import { OptionDefinition } from './option-definition'

export class OptionGroupDefinition extends BaseOptionDefinition {
  public options: OptionDefinition[]

  constructor(optionGroup: OptionGroupDefinition) {
    super(optionGroup)
    this.options = (optionGroup.options || []).map((o) => new OptionDefinition(o))
  }
}
